<template>
    <div v-if="atendimento">
        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown"
            title="Integração Contself" id="integracao-contself-status-button" aria-haspopup="true"
            aria-expanded="false">
            <!-- <i class="fa fa-print" aria-hidden="true" v-if="icon !== false"></i> -->
            Contself
        </button>

        <div class="dropdown-menu" aria-labelledby="integracao-contself-status-button">
            <a class="dropdown-item" href="#" @click="consultarContself()">
                Consultar 
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" @click="logComunicacao()"><i class="fa-solid fa-book fa-fw mr-2"></i>Log
                de
                Comunicação</a>
        </div>

        <log-integracao ref="logInt" />

        <pre v-if="1 == 0">{{ atendimento }}</pre>
    </div>
</template>

<script>
// import $ from "jquery";
// import _ from "lodash";
import LogIntegracao from "../shared/audit/LogIntegracao.vue";

export default {
    data() {
        return {

        };
    },

    props: {
        atendimento: {
            type: Object,
            required: true
        }
    },

    components: {
        // AzInput,
        LogIntegracao,
        // AzAudioRecorder,
    },

    methods: {
        consultarContself: function () {
            this.$util.atualizar(this, {
                service: 'atendimentos',
                func: 'consultar_contself',
                dados: {
                    id: this.atendimento.id_atendimento,
                },
            });

            // this.$util.atualizar(this, {
            //     service: "pep",
            //     func: "enviar_pacs",
            //     dados: {
            //         id_atendimento_procedimento:
            //             atp.id_atendimento_procedimento,
            //         id_atendimento: atp.id_atendimento,
            //         reenviar: true
            //     },
            //     callback: res => {
            //         this.$toast.add({
            //             severity: res.status_code == 200 ? "success" : "error",
            //             summary: "Atenção",
            //             detail: res.msg
            //                 ? res.msg
            //                 : "Erro ao enviar procedimento para o PACS",
            //             life: 3000
            //         });
            //     }
            // });
        },

        logComunicacao: function () {
            // this.$refs.azAudioRec.abrir()
            this.$refs.logInt.abrir(
                "atendimento",
                this.atendimento.id_atendimento,
                true
            );
        }
    },

    mounted() {
    },

};
</script>
